/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Error_UnknownInputs */

const en_us2_body_assessment_error_unknown = /** @type {(inputs: Body_Assessment_Error_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This assessment couldn't be computed. Try retaking the photos following the tips.`)
};

const pt_br2_body_assessment_error_unknown = /** @type {(inputs: Body_Assessment_Error_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não deu para calcular esta avaliação. Tente refazer as fotos seguindo as dicas.`)
};

const es_419_body_assessment_error_unknown = /** @type {(inputs: Body_Assessment_Error_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo calcular esta evaluación. Intenta volver a tomar las fotos siguiendo los consejos.`)
};

const pt_pt2_body_assessment_error_unknown = /** @type {(inputs: Body_Assessment_Error_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível calcular esta avaliação. Tenta repetir as fotos seguindo as dicas.`)
};

const fr_fr2_body_assessment_error_unknown = /** @type {(inputs: Body_Assessment_Error_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de calculer cette évaluation. Reprends les photos en suivant les conseils.`)
};

const de_de2_body_assessment_error_unknown = /** @type {(inputs: Body_Assessment_Error_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Messung ließ sich nicht berechnen. Mach die Fotos nach den Tipps neu.`)
};

const it_it2_body_assessment_error_unknown = /** @type {(inputs: Body_Assessment_Error_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non è stato possibile calcolare questa valutazione. Prova a rifare le foto seguendo i consigli.`)
};

/**
* | output |
* | --- |
* | "This assessment couldn't be computed. Try retaking the photos following the tips." |
*
* @param {Body_Assessment_Error_UnknownInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_error_unknown = /** @type {((inputs?: Body_Assessment_Error_UnknownInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Error_UnknownInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_error_unknown(inputs)
	if (locale === "es-419") return es_419_body_assessment_error_unknown(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_error_unknown(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_error_unknown(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_error_unknown(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_error_unknown(inputs)
	return en_us2_body_assessment_error_unknown(inputs)
});
export { body_assessment_error_unknown as "body-assessment.error.unknown" }